import type { FeaturesDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FeaturesService {
  apiName = 'Default';
  

  get = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, FeaturesDto>({
      method: 'GET',
      url: '/api/app/features',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
